import type { IIdentityVerificationModel } from './Types';

export default (identityVerification: IIdentityVerificationModel) => {
  const { additionalVerificationRequired, legalEntityVerificationStatus } = identityVerification;
  return {
    additionalVerificationRequired: Boolean(additionalVerificationRequired),
    legalEntityVerificationStatus: legalEntityVerificationStatus && String(legalEntityVerificationStatus),
  };
};
